<template>
  <div class="grid">
    <div class="grid-item" @click="itemMenu('banner')">
      {{ $t("nav[0]") }}
    </div>
    <div class="grid-item" @click="itemMenu('about')">
      {{ $t("nav[5]") }}
    </div>
    <div class="grid-item" @click="itemMenu('highlights')">
      {{ $t("nav[6]") }}
    </div>
    <div class="grid-item" @click="itemMenu('solutions')">
      {{ $t("nav[1]") }}
    </div>
    <div class="grid-item" @click="itemMenu('industries')">
      {{ $t("nav[2]") }}
    </div>
    <div class="grid-item" @click="itemMenu('work')">
      {{ $t("nav[3]") }}
    </div>
    <div class="grid-item" @click="itemMenu('allies')">
      {{ $t("nav[4]") }}
    </div>
  </div>
</template>
<script>
export default {
  name: "menu-modal",
  data() {
    return {
      title: "menu-modal",
    };
  },
  methods: {
    itemMenu(route) {
      if (this.$route.name == "home") this.$scrollTo("#" + route);
      else this.$router.push({ path: "/#" + route });
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.grid {
  --grid-layout-gap: 20px;
  --grid-column-count: 4;
  --grid-item--min-width: 100px;
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );
  display: grid;
  margin: 2rem;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}
.grid-item {
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 5px;
  border: solid 1px #eaeaea;
  box-shadow: 1px 1px 1px #eaeaea;
  text-align: center;
}
.grid-item:hover {
  background-color: #ebebeb;
}
</style>
<i18n>
{
  "es": {
      "nav": ["Inicio ","Módulos","Industrias","Cómo Funciona","Alianzas","Quiénes somos","Destacados"]
  },
  "en": {
      "nav": ["Home", "Modules", "Industries", "How it works", "Alliances", "About us", "Highlights"]
  },
  "pt": {
      "nav": ["Inicio", "Módulos", "Indústrias", "Como funciona", "Alianças", "Quem somos", "Destaque"]
  }
}
</i18n>